/** Pair two arrays element-wise; truncates to the shorter one. */
export const zip = <A, B>(a: A[], b: B[]): [A, B][] => {
  const length = Math.min(a.length, b.length)
  const out: [A, B][] = new Array(length)
  for (let i = 0; i < length; i++) out[i] = [a[i], b[i]]
  return out
}
